import React, { createContext, useContext, useState } from 'react';

export interface OtpInformation {
  mobilePhone: string;
  otpRefCode: string;
}

interface IOtpContextProps {
  otpInformation: OtpInformation | null;
  setOtpInformation: (otpInformation: OtpInformation | null) => void;
}

const OtpContext = createContext<IOtpContextProps | undefined>(undefined);

interface IOtpProviderProps {
  children: React.ReactNode;
}

export const OtpProvider = ({ children }: IOtpProviderProps) => {
  const [otpInformation, setOtpInformation] = useState<OtpInformation | null>(null);

  return (
    <OtpContext.Provider value={{ otpInformation: otpInformation, setOtpInformation: setOtpInformation }}>
      {children}
    </OtpContext.Provider>
  )
}

export const useOtpContext = () => {
  const context = useContext(OtpContext);
  if (!context) {
    throw new Error("useOtpContext must be used within a OtpProvider");
  }

  return context;
}